import { cn } from '#app/utils/misc.tsx'

/**
 * The frame for the Tailwind pages outside the app shell (marketing, auth,
 * settings) in the herontwerp language (ADR-027 §1–2): one hairline card
 * on the ivory ground, the Onest scale — page title 30/800 −0.02em, intro
 * 15/400 muted — and 20px page padding. The app surfaces use oy.css; these
 * pages share only the tokens.
 */
export function PageFrame({
	size = 'sm',
	className,
	children,
}: {
	/** sm 440px (forms), md 640px (settings, prose) */
	size?: 'sm' | 'md'
	className?: string
	children: React.ReactNode
}) {
	return (
		<div
			className={cn(
				'mx-auto w-full px-5 pt-6 pb-24 md:pt-10',
				size === 'sm' ? 'max-w-[480px]' : 'max-w-[680px]',
				className,
			)}
		>
			{children}
		</div>
	)
}

export function PageCard({
	as: Tag = 'section',
	className,
	children,
	...props
}: Omit<React.ComponentProps<'section'>, 'ref'> & {
	as?: 'section' | 'main' | 'div'
}) {
	return (
		<Tag
			className={cn(
				'bg-card border-border rounded-[20px] border px-5 py-6 sm:px-7 sm:py-8',
				className,
			)}
			{...props}
		>
			{children}
		</Tag>
	)
}

export function PageTitle({
	title,
	intro,
	align = 'left',
	className,
}: {
	title: React.ReactNode
	intro?: React.ReactNode
	align?: 'left' | 'center'
	className?: string
}) {
	return (
		<div className={cn(align === 'center' && 'text-center', className)}>
			<h1 className="text-[30px] leading-[1.15] font-extrabold tracking-[-0.02em]">
				{title}
			</h1>
			{intro ? (
				<p className="text-muted-foreground mt-2 text-[15px] leading-[1.45]">
					{intro}
				</p>
			) : null}
		</div>
	)
}
